import React from "react";
import { Container, Description, Image, Title, ContainerFooter, LinkFooter } from "./styles";

function Item({ item, index }) {
  const { image, title, description, titleColor, textColor } = item;

  return (
    <Container>
      <Image>
        <img
          src={`https://${image.fields.file.url}`}
          alt={image.fields.title}
        />
      </Image>
      <Title color={titleColor}>{title}</Title>
      <Description color={textColor} index={index}>
        {description}
      </Description>
      {index === 2 && (
        <ContainerFooter>
          <LinkFooter href='https://veloe.com.br/onde-usar/mapa/' target='blank'>
            Ver cobertura
          </LinkFooter>
        </ContainerFooter>
      )}
    </Container>
  );
}

export default Item;
